<template>
  <ReactSiteFrame :src="src" />
</template>
<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'PreorderReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: '/view/preorders'
    }
  }
}
</script>